var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.932 16.185a.72.72 0 00.714-.705V6.203l-.054-1.355.614.641 1.364 1.463a.66.66 0 00.488.217.63.63 0 00.659-.641.63.63 0 00-.208-.47L9.456 3.114c-.181-.181-.343-.244-.524-.244s-.343.063-.524.244L5.354 6.059c-.136.136-.217.28-.217.47 0 .37.28.641.65.641.181 0 .37-.072.497-.217L7.658 5.49l.614-.641-.063 1.355v9.277c0 .379.334.705.723.705zm-5.185 7.073h10.361c1.888 0 2.836-.939 2.836-2.8v-9.015c0-1.861-.948-2.8-2.836-2.8h-2.52v1.454h2.493c.894 0 1.409.488 1.409 1.427v8.853c0 .939-.515 1.427-1.409 1.427H3.765c-.903 0-1.4-.488-1.4-1.427v-8.853c0-.939.497-1.427 1.4-1.427h2.502V8.642h-2.52c-1.888 0-2.836.939-2.836 2.8v9.015c0 1.861.948 2.8 2.836 2.8z"
  })));
}

export default SvgShareChannel;